module.exports = __webpack_public_path__ + "static/img/200315.1d245280.png";